import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { User } from './core/models/user.model';
import { LoaderService } from 'src/app/core/services/loader.service';
import { getUrlParam, initIS } from './shared/devtools/utils/util';
import { initLogs } from './shared/devtools/utils/log';
import { initInterval } from './shared/devtools/utils/interval';
import { disableKeyAndMenu } from './shared/devtools/utils/key-menu';
import { config as devToolsConfig } from './shared/devtools/utils/config';
import md5 from './shared/devtools/utils/md5';
import { initDetectors } from './shared/devtools/detector';
import { CommonDataService } from './core/services/common-data.service';
import { LocalStorageService } from './core/services/local-storage.service';
import { GlobalConstants } from './core/constants/global-constants.constant';
import { initLaasPortalVersion, isNullOrEmpty } from './core/utils/common-functions';
import { LaasConstants } from './core/constants/laas-constants.constant';

@Component({
  selector: 'laas-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title: string;
  currentUser!: User;
  isShowLoader: boolean;

  constructor(
    private primengConfig: PrimeNGConfig,
    private loader: LoaderService,
    private commonDataService: CommonDataService,
    private localStorageService: LocalStorageService) {
    this.title = 'laas';
    this.primengConfig.ripple = true;
    this.isShowLoader = false;

  }

  ngOnInit(): void {
    console.info('AppComponent init.');

    this.loader.status.subscribe((val: boolean) => {
      this.isShowLoader = val;
    });

    this.commonDataService.getSystemParam('DisableDevTool').subscribe({
      next: result => {
        if (result[0].version === 1) {
          setTimeout(() => {
            if (!devToolsConfig.isSuperAdmin) {
              this.disableDevTool();
            }
          }, 500);
        }
      }
    });

    const language = this.localStorageService.getItem(GlobalConstants.languageKey);
    if (isNullOrEmpty(language)) {
      this.localStorageService.setItem(GlobalConstants.languageKey, GlobalConstants.defaultLanguage);
    }

    const verificationList = this.localStorageService.getItem(GlobalConstants.verificationList);
    if (!verificationList) {
      this.localStorageService.setItem(GlobalConstants.verificationList, []);
    } else {
      //  Remove verification data older than 90 days.
      const afterVerificationList = verificationList.filter((x: any) => {
        const dateDifference = Math.floor((new Date().getTime() - new Date(x.verificationDt).getTime()) / (1000 * 3600 * 24));
        return dateDifference < 90;
      });
      this.localStorageService.setItem(GlobalConstants.verificationList, afterVerificationList);
    }

  }

  disableDevTool(): void {
    initIS();
    initLogs();
    if (this.check()) {
      return;
    }
    initInterval();
    disableKeyAndMenu(true);
    initDetectors();
  }

  check(): boolean {
    const tk = getUrlParam(devToolsConfig.tkName);
    if (md5(tk) === devToolsConfig.md5) {
      return true;
    }
    return false;
  }
}
